import React from 'react';
import { CapaQuotationDetailedQuotation } from '@generated/graphql';
import { QuotationListDrawer } from '@components/Form/ReceivedQuotationForm/Common';

interface Props {
  quotations: CapaQuotationDetailedQuotation[];
  onClick: (id: string) => void;
}

const CreatePurchaseOrderDropdownPresenter = ({
  quotations,
  onClick
}: Props) => {
  const items = quotations.map((item) => ({
    id: item.id ?? '',
    dueDate: item.dueDate ?? '',
    createdAt: item.createdAt ?? '',
    quotationPrice: item.quotation ?? 0,
    isLatest: item.latest ?? false
  }));

  return (
    <QuotationListDrawer
      items={items}
      title="견적서 발행이력"
      onClick={onClick}
    />
  );
};

export default CreatePurchaseOrderDropdownPresenter;
